import http from '@/base/api/public'
let apiUrl = require('@/../config/sysConfig')
import querystring from 'querystring'

// 初期化
export const home = () => {
    return http.requestQuickGet(apiUrl.apiUrl_Initialization)
}

// 作業量一覧検索
export const w0001_query = (params) => {
    let querys = querystring.stringify(params)
    return http.requestGet(apiUrl.apiUrl_workAmountList + '?' + querys)
}


// WEBPACK FOOTER //
// ./src/module/api/w_0001.js